module.exports = __webpack_public_path__ + "img/IranMap.5338281.svg";